export const B_CLIENT_ICONS = {
  x1: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/b_client_icon_x1.png',
  x2: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/b_client_icon_x2.png',
};

export const C_CLIENT_ICONS = {
  x1: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/c_client_icon_x1.png',
  x2: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/c_client_icon_x2.png',
};
